import React from 'react'
import * as Ariakit from '@ariakit/react'
import Button from 'components/Button'
import { useTranslation } from 'react-i18next'
import { Dialog } from 'components/Dialog'
import { CancelDispatchState } from './CancelDispatchState'

export function CancelDispatch({
  callKey,
  provider,
  service,
  cancelDisabled,
}: {
  callKey: string
  provider: string
  service: any
  cancelDisabled?: boolean
}) {
  const { t } = useTranslation()
  const dialog = Ariakit.useDialogContext()

  return (
    <>
      <Button.Primary disabled={cancelDisabled} onClick={dialog?.show} style={{ width: '100%' }}>
        {t('cancelDispatch.cancelService')}
      </Button.Primary>
      <Dialog {...dialog!} aria-label="Cancel dispatch">
        <CancelDispatchState callKey={callKey} provider={provider} service={service} />
      </Dialog>
    </>
  )
}

export default CancelDispatch
